import React from "react";

const ITEMS = [
    "ISO 20700",
    "Six Sigma Black Belt",
    "Prosci® Change",
    "PMP®",
    "Vested®",
    "COPC®",
    "ISO 20700",
    "Six Sigma Black Belt",
    "Prosci® Change",
    "PMP®",
    "Vested®",
    "COPC®",
];

export default function StandardsMarquee() {
    return (
        <section
            data-testid="standards-marquee"
            aria-label="Industry standards and certifications"
            className="relative py-10 border-y border-gray-200 bg-gray-50 overflow-hidden"
        >
            <div className="dashed-divider absolute top-0 left-0 right-0 opacity-30" />
            <div className="flex items-center gap-12 animate-marquee whitespace-nowrap will-change-transform">
                {[...ITEMS, ...ITEMS].map((item, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-4 shrink-0"
                        data-testid={`marquee-item-${i}`}
                    >
                        <span className="h-1.5 w-1.5 rounded-full bg-bpo-cyan" />
                        <span className="text-sm md:text-base font-bold tracking-[0.22em] text-bpo-charcoal/70 uppercase">
                            {item}
                        </span>
                    </div>
                ))}
            </div>
            <div className="dashed-divider absolute bottom-0 left-0 right-0 opacity-30" />
        </section>
    );
}
